import eMediaAPI from '@/services/api/internal/eMediaAPI';
import { ACTIONS_NATURE_ID } from '@/store/eMediaModule';

async function getDocuments(params) {
  const queryParams = {
    property_id: params.propertyId.toString(),
    filter_document_title: '**',
    page_index: params.pageIndex,
    page_size: params.pageSize,
    sort_order: params.orderByText,
  };
  if (params.interventionId) {
    queryParams.filter_intervention_id = params.interventionId;
    queryParams.filter_intervention_type = 'preventive';
  }
  if (params.actionId) {
    queryParams.filter_nature_id = ACTIONS_NATURE_ID;
    queryParams.filter_technical_element = params.actionId.toString();
  } else {
    queryParams.filter_nature_id = params.filters.nature
      ? `exp/${params.filters.nature}`
      : null;
    queryParams.filter_category_id = params.filters.category;
    queryParams.filter_internal =
      params.filters.internal && params.filters.internal.length === 1
        ? params.filters.internal[0]
        : null;
  }
  return eMediaAPI.getDocuments({
    input: '',
    params: queryParams,
  });
}

async function getCategories() {
  return eMediaAPI.getCategories({});
}

async function downloadDocument(uid) {
  return eMediaAPI.downloadDocument(uid);
}

async function deleteDocument(uid, gid) {
  const body = {
    input: '',
    params: {
      id: uid,
      delete_comment: `Suppression MyPredity par ${gid}`,
    },
  };
  return eMediaAPI.deleteDocument(body);
}

function getMimeType(file) {
  return (file && file.type) || 'application/octet-stream';
}

async function uploadDocument(params) {
  const data = {
    input: null,
    params: {
      property_id: params.propertyId.toString(),
      title: params.title,
      nature_id: `exp/${params.nature}`,
      internal: !params.visible,
      comment: params.comment,
      document_source: 'myPredity Action',
      filename: params.file.name,
      mime_type: getMimeType(params.file),
    },
  };
  if (params.action) {
    data.params.technical_element = params.actionId.toString();
    data.params.nature_id = ACTIONS_NATURE_ID;
  }
  return eMediaAPI
    .uploadDocument(params.file, data)
    .then((response) => {
      return (
        response.document_id ||
        response['EmediaCDC.EXP.AddPropertyDocument'].uuid
      );
    })
    .catch((error) => {
      const err =
        error.response && error.response.data
          ? error.response.data.value.errors
          : error;
      throw err;
    });
}

async function uploadDocumentFromPaste(params) {
  const data = {
    input: null,
    params: {
      property_id: params.propertyId.toString(),
      technical_element: params.actionId.toString(),
      title: `Document_Colle_Action_${params.actionId}`,
      internal: true,
      nature_id: ACTIONS_NATURE_ID,
      comment: '',
      document_source: 'myPredity Action',
      filename: `Document_Colle_Action_${params.actionId}.png`,
      mime_type: getMimeType(params.file),
    },
  };

  return eMediaAPI
    .uploadDocument(params.file, data)
    .then((response) => {
      return (
        response.document_id ||
        response['EmediaCDC.EXP.AddPropertyDocument'].uuid
      );
    })
    .catch((error) => {
      const err =
        error.response && error.response.data
          ? error.response.data.value.errors
          : error;
      throw err;
    });
}

async function getRequestDocuments(id) {
  const body = {
    input: '',
    params: {
      intervention_request_id: id.toString(),
    },
  };
  return eMediaAPI
    .getRequestDocuments(body)
    .then((response) => response.documents);
}

async function downloadRequestDocument(id) {
  return eMediaAPI.downloadRequestDocument(id);
}
export {
  getDocuments,
  getCategories,
  downloadDocument,
  deleteDocument,
  uploadDocument,
  uploadDocumentFromPaste,
  getRequestDocuments,
  downloadRequestDocument,
};
